<div *ngIf="updatedAt" class="text-muted small mt-4">
  Last updated on
  {{ dateStringFromISO8601(updatedAt, orgConfig.getOrganizationConfig().time_zone) }}
  at
  {{ timeStringFromISO8601(updatedAt, orgConfig.getOrganizationConfig().time_zone) }}<ng-container
    *ngIf="hasStaffUser"
  > by {{ getStaffNameDisplay(firstName, lastName, email) }}</ng-container>
</div>
